export const REVOLUT_SUPPORTED_MARKETS = ['RO', 'CZ', 'HU'];
export const ING_SUPPORTED_MARKETS = ['SK', 'HR', 'LT', 'LV', 'EE', 'BG'];

export const PROVIDER_MARKETS = {
	Revolut: REVOLUT_SUPPORTED_MARKETS,
	ING: ING_SUPPORTED_MARKETS,
};
